module.exports = __webpack_public_path__ + "static/media/hausa.ebde243a.svg";